import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Search: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M14 5a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM3 14a11 11 0 1 1 19.45 7.04l6.26 6.25a1 1 0 0 1-1.42 1.42l-6.25-6.26A11 11 0 0 1 3 14Z"
    />
  </Icon>
);
